/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable prefer-spread */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-destructuring */

import { TrackingIDs } from '../../@types/Tracking';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const loadedScripts = new Map<string, string>();

declare global {
  interface Window {
    dataLayer: any[];
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}

function removeScriptBySrcContains(tipo: string, pattern: string) {
  document.querySelectorAll('script').forEach((el) => {
    let id = el.getAttribute('id') ?? '';
    const src = el.getAttribute('src') ?? '';

    id = id.split('-')[0];

    if (id.includes(pattern)) {
      console.log('rm script:', id);
      el.remove();
    }

    if (
      src.includes(`connect.facebook.net/signals/config/`) &&
      pattern === 'pixel'
    ) {
      console.log('[MetaPixel] rm signals/config do pixel', pattern);
      el.remove();
    }
  });

  (function () {
    delete window.fbq;
    delete window._fbq;
  })();

  loadedScripts.delete(tipo);
}

function injectGoogleAnalytics(id: string, tipo = 'estabelecimento') {
  if (!id || loadedScripts.get(tipo) === id) return;
  loadedScripts.set(tipo, id);

  const script = document.createElement('script');
  script.id = `ga-${id}`;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  script.setAttribute('data-tracking', `ga-${id}`);
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', id);

  console.log('[GA] Script injected:', id);
}

function injectGoogleTagManager(id: string, tipo = 'estabelecimento') {
  if (!id || loadedScripts.get(tipo) === id) return;
  loadedScripts.set(tipo, id);

  const script = document.createElement('script');
  script.id = `gtm-${id}`;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  script.setAttribute('data-tracking', `gtm-${id}`);
  document.head.appendChild(script);

  console.log('[GTM] Script injected:', id);
}

function injectMetaPixel(id: string, tipo = 'estabelecimento') {
  if (!id || loadedScripts.get(tipo) === id) return;
  loadedScripts.set(tipo, id);

  if (!window.fbq) {
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod(...args);
        } else {
          n.queue.push(args);
        }
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];

      const t = b.createElement(e) as HTMLScriptElement;
      t.id = `pixel-${id}`;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s?.parentNode) s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    );

    console.log('[MetaPixel] Loading pixel...', id);
  }

  const interval = setInterval(() => {
    if (window.fbq) {
      window.fbq('init', id);
      window.fbq('track', 'ViewContent');
      clearInterval(interval);
    }
  }, 100);
}

export function injectsGaGtmPixel(trackingIDs: TrackingIDs) {
  if (trackingIDs.idGA) {
    if (trackingIDs.idGA && document.getElementById(`ga-${trackingIDs.idGA}`)) {
      return;
    }
    removeScriptBySrcContains('ga', 'ga');
    injectGoogleAnalytics(trackingIDs.idGA, trackingIDs.tipo);
  }
  if (trackingIDs.idGTM) {
    if (
      trackingIDs.idGTM &&
      document.getElementById(`pixel-${trackingIDs.idGTM}`)
    ) {
      return;
    }
    removeScriptBySrcContains('gtm', 'gtm');
    injectGoogleTagManager(trackingIDs.idGTM, trackingIDs.tipo);
  }
  if (trackingIDs.idPixel) {
    if (
      trackingIDs.idPixel &&
      document.getElementById(`pixel-${trackingIDs.idPixel}`)
    ) {
      return;
    }
    removeScriptBySrcContains('pixel', 'pixel');
    injectMetaPixel(trackingIDs.idPixel, trackingIDs.tipo);
  }
}
